    <!-- Left Panel -->

    <aside id="left-panel" class="left-panel">
        <nav class="navbar navbar-expand-sm navbar-default">

            <div id="main-menu" class="main-menu collapse navbar-collapse">

                <ul class="nav navbar-nav" id="mnr">

                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <a  routerLink="/admin/dashboard" ><i class="menu-icon fa fa-dashboard"></i>CEO Dashboard </a>
                    </li>

                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <a  routerLink="/admin/landingpage" ><i class="menu-icon fa fa-home"></i>Home </a>
                    </li>

                    <li class="menu-item-has-children dropdown" id="viewMenu" (click)="menuSubmenu('viewMenu')">
                        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-table"></i>View</a>
                        <ul class="sub-menu children dropdown-menu" id="subviewMenu">
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/flashView" ><i class="menu-icon fa fa-file"></i>Flash View</a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/filelist" ><i class="menu-icon fa fa-user"></i>Uploaded File List </a>
                            </li>
                        </ul>
                    </li>

                    <li class="menu-item-has-children dropdown" id="reportsMenu" (click)="menuSubmenu('reportsMenu')">
                        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-table"></i>Reports</a>
                        <ul class="sub-menu children dropdown-menu" id="subreportsMenu">
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/flashReport" ><i class="menu-icon fa fa-file"></i>Flash Report</a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/consolereport" ><i class="menu-icon fa fa-user"></i>Consolidated Report</a>
                            </li>
                            
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a routerLink="/admin/queryreport" ><i class="menu-icon fa fa-bar-chart"></i>Custom Report </a>
                            </li>
                        </ul>
                    </li>
                    
                    <li class="menu-item-has-children dropdown" id="auditMenu" (click)="menuSubmenu('auditMenu')">
                        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-table"></i>Audit</a>
                        <ul class="sub-menu children dropdown-menu" id="subauditMenu">
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/fileaudit" ><i class="menu-icon fa fa-file"></i>File Audit </a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/otherfileaudit" ><i class="menu-icon fa fa-file"></i>Other File Audit </a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/pendingreqaudit" ><i class="menu-icon fa fa-user"></i>Pending Request Audit</a>
                            </li>
                            
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/loginaudit" ><i class="menu-icon fa fa-file"></i>Login Audit </a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/useraudit" ><i class="menu-icon fa fa-file"></i>User Audit </a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/companyaudit" ><i class="menu-icon fa fa-lock"></i>Company Audit</a>
                            </li>
                        </ul>
                    </li>

                    <li class="menu-item-has-children dropdown" id="otherMenu" (click)="menuSubmenu('otherMenu')">
                        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-table"></i>Others</a>
                        <ul class="sub-menu children dropdown-menu" id="subotherMenu">
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/pendingreq" ><i class="menu-icon fa fa-user"></i>Pending Request </a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/fileMatrix" ><i class="menu-icon fa fa-user"></i>File Matrix</a>
                            </li>
                        </ul>
                    </li>

                    <li class="menu-item-has-children dropdown" id="companyMenu" (click)="menuSubmenu('companyMenu')">
                        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-table"></i>Company Setting</a>
                        <ul class="sub-menu children dropdown-menu" id="subcompanyMenu">
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/addcompany" ><i class="menu-icon fa fa-industry"></i>Company Create </a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/listcompany" ><i class="menu-icon fa fa-industry"></i>Company List </a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/adduser" ><i class="menu-icon fa fa-user"></i>User Add </a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/userlist" ><i class="menu-icon fa fa-user"></i>User List </a>
                            </li>
                        </ul>
                    </li>

                    <li class="menu-item-has-children dropdown" id="adminMenu" (click)="menuSubmenu('adminMenu')">
                        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-table"></i>Admin Setting</a>
                        <ul class="sub-menu children dropdown-menu" id="subadminMenu">
                           
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/datalockconfig" ><i class="menu-icon fa fa-lock"></i>Data Lock Settings</a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/unlocksettings" ><i class="menu-icon fa fa-unlock"></i>Data Unlock Settings</a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/emailconfig" ><i class="menu-icon fa fa-unlock"></i>Email Settings</a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/pdapprove" ><i class="menu-icon fa fa-unlock"></i>Public dashboard Approval</a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/helpdoc" ><i class="menu-icon fa fa-question-circle"></i>Help Document </a>
                            </li>
                        </ul>
                    </li>




                	
                    
                    
                    
                    
                    
                    <!--<li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <a routerLink="/admin/companylist" ><i class="menu-icon fa fa-eye"></i>View File </a>
                    </li>-->
                   <!-- <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                         <a routerLink="/analyst/consoleReport"><i class="menu-icon fa fa-bar-chart"></i>Consolidated Report</a>
                    </li>-->

                    <!-- /.menu-title -->
                  <!--<li class="menu-title">UI elements</li>-->
                    <!--<li class="menu-item-has-children dropdown" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <a class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="showSubmenu = !showSubmenu"> <i class="menu-icon fa fa-cogs"></i>Flash</a>
                        <ul class="sub-menu children dropdown-menu" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">                           
                             <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/admin/flashView" ><i class="menu-icon fa fa-file"></i>Flash View</a>
                            </li>
                             <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <a  routerLink="/admin/flashReport" ><i class="menu-icon fa fa-file"></i>Flash Report</a>
                    </li>
                        </ul>
                    </li>-->
                   <!--    <li class="menu-item-has-children active dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-table"></i>Tables</a>
                        <ul class="sub-menu children dropdown-menu">
                            <li><i class="fa fa-table"></i><a href="tables-basic.html">Basic Table</a></li>
                            <li><i class="fa fa-table"></i><a href="tables-data.html">Data Table</a></li>
                        </ul>
                    </li>
                    <li class="menu-item-has-children dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-th"></i>Forms</a>
                        <ul class="sub-menu children dropdown-menu">
                            <li><i class="menu-icon fa fa-th"></i><a href="forms-basic.html">Basic Form</a></li>
                            <li><i class="menu-icon fa fa-th"></i><a href="forms-advanced.html">Advanced Form</a></li>
                        </ul>
                    </li>

                    <li class="menu-title">Icons</li>

                    <li class="menu-item-has-children dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-tasks"></i>Icons</a>
                        <ul class="sub-menu children dropdown-menu">
                            <li><i class="menu-icon fa fa-fort-awesome"></i><a href="font-fontawesome.html">Font Awesome</a></li>
                            <li><i class="menu-icon ti-themify-logo"></i><a href="font-themify.html">Themefy Icons</a></li>
                        </ul>
                    </li>
                    <li>
                        <a href="widgets.html"> <i class="menu-icon ti-email"></i>Widgets </a>
                    </li>
                    <li class="menu-item-has-children dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-bar-chart"></i>Charts</a>
                        <ul class="sub-menu children dropdown-menu">
                            <li><i class="menu-icon fa fa-line-chart"></i><a href="charts-chartjs.html">Chart JS</a></li>
                            <li><i class="menu-icon fa fa-area-chart"></i><a href="charts-flot.html">Flot Chart</a></li>
                            <li><i class="menu-icon fa fa-pie-chart"></i><a href="charts-peity.html">Peity Chart</a></li>
                        </ul>
                    </li>

                    <li class="menu-item-has-children dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-area-chart"></i>Maps</a>
                        <ul class="sub-menu children dropdown-menu">
                            <li><i class="menu-icon fa fa-map-o"></i><a href="maps-gmap.html">Google Maps</a></li>
                            <li><i class="menu-icon fa fa-street-view"></i><a href="maps-vector.html">Vector Maps</a></li>
                        </ul>
                    </li>
                    <li class="menu-title">Extras</li>
                    <li class="menu-item-has-children dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-glass"></i>Pages</a>
                        <ul class="sub-menu children dropdown-menu">
                            <li><i class="menu-icon fa fa-sign-in"></i><a href="page-login.html">Login</a></li>
                            <li><i class="menu-icon fa fa-sign-in"></i><a href="page-register.html">Register</a></li>
                            <li><i class="menu-icon fa fa-paper-plane"></i><a href="pages-forget.html">Forget Pass</a></li>
                        </ul>
                    </li> -->
                </ul>
            </div><!-- /.navbar-collapse -->
             
        </nav>
    </aside><!-- /#left-panel -->
        <!-- Right Panel -->

    <div id="right-panel" class="right-panel">

        <!-- Header-->
        <header id="header" class="header">
            <div class="top-left">
                <div class="navbar-header">
                    <a class="navbar-brand" href="./"><img src="./assets/images/gic-header-logo.jpg" alt="Logo"></a>
                    <a class="navbar-brand hidden" href="./"><img src="./assets/images/gic-header-logo.jpg" alt="Logo"></a>
                    <a id="menuToggle" class="menutoggle" (click)="sideNavToggle()" ><i class="fa fa-bars"></i></a>
                </div>
            </div>
            <div class="top-right">
                <div class="header-menu">
                    <!--<div class="header-left">
                        <button class="search-trigger"><i class="fa fa-search"></i></button>
                        <div class="form-inline">
                            <form class="search-form">
                                <input class="form-control mr-sm-2" type="text" placeholder="Search ..." aria-label="Search">
                                <button class="search-close" type="submit"><i class="fa fa-close"></i></button>
                            </form>
                        </div>

                        <div class="dropdown for-notification">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="notification" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fa fa-bell"></i>
                                <span class="count bg-danger">3</span>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="notification">
                                <p class="red">You have 3 Notification</p>
                                <a class="dropdown-item media" href="#">
                                    <i class="fa fa-check"></i>
                                    <p>Server #1 overloaded.</p>
                                </a>
                                <a class="dropdown-item media" href="#">
                                    <i class="fa fa-info"></i>
                                    <p>Server #2 overloaded.</p>
                                </a>
                                <a class="dropdown-item media" href="#">
                                    <i class="fa fa-warning"></i>
                                    <p>Server #3 overloaded.</p>
                                </a>
                            </div>
                        </div>

                        <div class="dropdown for-message">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="message" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fa fa-envelope"></i>
                                <span class="count bg-primary">4</span>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="message">
                                <p class="red">You have 4 Mails</p>
                                <a class="dropdown-item media" href="#">
                                    <span class="photo media-left"><img alt="avatar" src="./assets/images/avatar/1.jpg"></span>
                                    <div class="message media-body">
                                        <span class="name float-left">Jonathan Smith</span>
                                        <span class="time float-right">Just now</span>
                                        <p>Hello, this is an example msg</p>
                                    </div>
                                </a>
                                <a class="dropdown-item media" href="#">
                                    <span class="photo media-left"><img alt="avatar" src="./assets/images/avatar/2.jpg"></span>
                                    <div class="message media-body">
                                        <span class="name float-left">Jack Sanders</span>
                                        <span class="time float-right">5 minutes ago</span>
                                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                                    </div>
                                </a>
                                <a class="dropdown-item media" href="#">
                                    <span class="photo media-left"><img alt="avatar" src="./assets/images/avatar/3.jpg"></span>
                                    <div class="message media-body">
                                        <span class="name float-left">Cheryl Wheeler</span>
                                        <span class="time float-right">10 minutes ago</span>
                                        <p>Hello, this is an example msg</p>
                                    </div>
                                </a>
                                <a class="dropdown-item media" href="#">
                                    <span class="photo media-left"><img alt="avatar" src="./assets/images/avatar/4.jpg"></span>
                                    <div class="message media-body">
                                        <span class="name float-left">Rachel Santos</span>
                                        <span class="time float-right">15 minutes ago</span>
                                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>-->
                    <div  class="uarea">Hello, <br> {{userName}}</div>
                    <div class="user-area dropdown float-right" id="ddMenu">
                        <a  class="dropdown-toggle active" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="ddToggleMenu()" (blur)="ddToggleMenu()">
                            <img class="user-avatar rounded-circle" src="./assets/images/giconlylogo.png" alt="User Avatar">
                        </a>

                        <div class="user-menu dropdown-menu" id="ddLogout">
                            <a class="nav-link" href="#" (click)="glogout()"  ><i class="fa fa-power-off"></i>Logout</a>
                            <a class="nav-link" style="cursor: pointer;" (click)="gochgPsw()"  ><i class="fa fa-user"></i>Change Password</a>
                        </div>
                    </div>
                </div>
            </div>
        </header><!-- /header -->
        <!-- Header-->

       <!-- <div class="breadcrumbs">
            <div class="breadcrumbs-inner">
                <div class="row m-0">
                    <div class="col-sm-4">
                        <div class="page-header float-left">
                            <div class="page-title">
                                <h1>Dashboard</h1>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-8">
                        <div class="page-header float-right">
                            <div class="page-title">
                                <ol class="breadcrumb text-right">
                                    <li><a href="#">Dashboard</a></li>
                                    <li><a href="#">Table</a></li>
                                    <li class="active">Data table</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->

        <div class="content">
          <router-outlet></router-outlet>
        </div><!-- .content -->


        <div class="clearfix"></div>

        <footer class="site-footer">
            <div class="footer-inner bg-white">
                <div class="row">
                    <div class="col-sm-6">
                        Copyright &copy; {{anio}} General Insurance Council
                    </div>
                    <div class="col-sm-6 text-right">
                       Designed by Pentation Analytics Pvt. Ltd.
                    </div>
                </div>
            </div>
        </footer>

    </div><!-- /#right-panel -->

    <!-- Right Panel -->

   



